import { MrAdvancedResultsLayoutDS } from '@net7/boilerplate-muruca';

export class CalderonAdvancedResultsLayoutDS extends MrAdvancedResultsLayoutDS {
  updateSearchTags(params) {
    if (!this.pageConfig.filters) {
      return;
    }

    const { labels, groups, valueMap } = this.pageConfig.filters;

    // Collect all param keys managed by groups
    const groupParamKeys = new Set<string>();
    if (groups) {
      groups.forEach((group) => {
        ['operator', 'value', 'unit', 'start', 'end'].forEach((key) => {
          if (group[key]) groupParamKeys.add(group[key]);
        });
      });
    }

    const tags = {};

    // Standard label params
    Object.keys(labels)
      .filter((key) => !!params[key])
      .forEach((key) => { tags[key] = params[key]; });

    // Group params (not in labels)
    groupParamKeys.forEach((key) => {
      if (params[key]) tags[key] = params[key];
    });

    this.one('mr-advanced-search-tags').updateOptions({ labels, groups, valueMap });
    this.one('mr-advanced-search-tags').update(tags);
  }
}
